import React, { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import {
  MoreVert as MoreVertIcon,
  Visibility as AuditIcon,
  Timeline as TimelineIcon,
  Edit as EditIcon,
  Science as SimulateIcon,
  ToggleOn as ToggleOnIcon,
} from "@mui/icons-material";

interface ShipmentActionsMenuProps {
  onAuditLog: () => void;
  onTimeline: () => void;
  onEdit: () => void;
  onSimulate: () => void;
  onChangeStatus: () => void;
}

export function ShipmentActionsMenu({
  onAuditLog,
  onTimeline,
  onEdit,
  onSimulate,
  onChangeStatus,
}: ShipmentActionsMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action: () => void) => {
    handleClose();
    action();
  };

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => handleAction(onAuditLog)}>
          <ListItemIcon>
            <AuditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Audit Log</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAction(onTimeline)}>
          <ListItemIcon>
            <TimelineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Timeline</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAction(onEdit)}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAction(onSimulate)}>
          <ListItemIcon>
            <SimulateIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Simulate Reminders & Actions</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAction(onChangeStatus)}>
          <ListItemIcon>
            <ToggleOnIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Toggle Status</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
